<script setup lang="ts">
// Material Symbols `home`, filled — the Dashboard nav glyph (matches investor-app tab bar). Colour follows CSS `color`.
defineOptions({ inheritAttrs: false })
</script>

<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    v-bind="$attrs"
  >
    <path
      d="M6.00125 19H9.00125V13H15.0012V19H18.0012V10L12.0012 5.5L6.00125 10V19ZM4.00125 21V9L12.0012 3L20.0012 9V21H13.0012V15H11.0012V21H4.00125Z"
      fill="currentColor"
    />
  </svg>
</template>
